// Black Friday landing: show the sticky phone button only after the hero button scrolls away and before the final block.
(function () {
  var root = document.querySelector('.bf');
  if (!root) return;
  var bar = root.querySelector('.bf-sticky');
  var cta = root.querySelector('.bf-hero .bf-claim');
  var end = root.querySelector('.bf-final');
  if (!bar || !cta || !end) return;
  var queued = false;
  function update() {
    queued = false;
    var pastHero = cta.getBoundingClientRect().bottom < 0;
    var atEnd = end.getBoundingClientRect().top < window.innerHeight * 0.85;
    bar.classList.toggle('is-on', pastHero && !atEnd);
  }
  function request() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);
  update();
})();

// After the deadline the page switches to its "see you next year" sign-up (CSS hides the offer under .bf--over).
// ponytail: the visitor's clock decides; a wrong clock shows the wrong state, but the bundle price itself is set on the product.
(function () {
  var root = document.querySelector('.bf[data-bf-end]');
  if (!root) return;
  var end = Date.parse(root.getAttribute('data-bf-end'));
  if (isNaN(end)) return;
  function check() { if (Date.now() >= end) { root.classList.add('bf--over'); return true; } return false; }
  if (!check()) { var t = setInterval(function () { if (check()) clearInterval(t); }, 1000); }
})();

// Black Friday countdown: every [data-bf-countdown] shows the time left until its ISO end date.
(function () {
  var timers = document.querySelectorAll('[data-bf-countdown]');
  if (!timers.length) return;
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    var now = Date.now();
    timers.forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-bf-countdown'));
      if (isNaN(end)) return;
      var left = Math.max(0, Math.floor((end - now) / 1000));
      el.classList.toggle('is-over', left === 0);
      var parts = { d: Math.floor(left / 86400), h: Math.floor(left / 3600) % 24, m: Math.floor(left / 60) % 60, s: left % 60 };
      Object.keys(parts).forEach(function (k) {
        var out = el.querySelector('[data-u="' + k + '"]');
        if (out) out.textContent = pad(parts[k]);
      });
    });
  }
  tick();
  setInterval(tick, 1000);
})();

// "Show more": [data-bf-more="N"] is cut to N lines; a toggle is added only where the text is actually longer.
// Without JS nothing is cut.
(function () {
  document.querySelectorAll('.bf [data-bf-more]').forEach(function (el) {
    el.style.setProperty('--bf-lines', el.getAttribute('data-bf-more'));
    el.classList.add('is-cut');
    if (el.scrollHeight <= el.clientHeight + 2) { el.classList.remove('is-cut'); return; }
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bf-more-btn';
    btn.textContent = 'Show more';
    btn.setAttribute('aria-expanded', 'false');
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-cut') === false;
      btn.textContent = open ? 'Show less' : 'Show more';
      btn.setAttribute('aria-expanded', String(open));
    });
    el.after(btn);
  });
})();

// Fade-up on scroll for content below the first screen. Items in the same list are staggered.
(function () {
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel = '.bf-kicker, .bf-h2, .bf-row, .bf-total, .bf-quotes li, .bf-test li, .bf-merge-photo, .bf-life-strip li, .bf-trust-years li, .bf-faq details, .bf-deal-gift, .bf-timer';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.bf ' + sel.split(', ').join(', .bf ')).forEach(function (el) {
    if (el.closest('.bf-hero') || el.getBoundingClientRect().top < window.innerHeight) return;
    var i = Array.prototype.indexOf.call(el.parentNode.children, el);
    el.style.transitionDelay = Math.min(i, 4) * 80 + 'ms';
    el.classList.add('bf-reveal');
    io.observe(el);
  });
})();

// Founder video: swap the poster for the YouTube player on click (no YouTube code loads before that).
(function () {
  document.querySelectorAll('.bf [data-bf-video]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(a.getAttribute('data-bf-video')) + '?autoplay=1&rel=0';
      f.title = 'Caribbrew founder video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      a.replaceChildren(f);
    });
  });
})();

// Hero email offer: the claim is remembered in this browser. The code itself ends with the sale and allows one use per customer.
(function () {
  var box = document.querySelector('.bf [data-bf-offer]');
  if (!box) return;
  var KEY = 'bf-offer-claimed-at';
  var form = box.querySelector('form');
  function save(t) { try { localStorage.setItem(KEY, String(t)); } catch (e) { /* the claim is lost on reload */ } }
  // The form posts normally and comes back to this page; a rejected email returns with .bf-claim-err, so the claim is undone.
  if (box.querySelector('.bf-claim-err')) { try { localStorage.removeItem(KEY); } catch (e) { /* nothing stored */ } return; }
  var claimed = false;
  try { claimed = !!localStorage.getItem(KEY); } catch (e) { /* treated as not claimed */ }
  form.addEventListener('submit', function () { save(Date.now()); });
  if (!claimed) return;
  box.querySelectorAll('[data-bf-offer-step]').forEach(function (el) { el.hidden = el.getAttribute('data-bf-offer-step') !== 'claimed'; });
  document.querySelectorAll('.bf [data-bf-claimed]').forEach(function (el) { el.hidden = false; });
  document.querySelectorAll('.bf [data-bf-sale]').forEach(function (el) { el.textContent = box.getAttribute('data-bf-offer-price'); });
})();

// Checkout links: ticked add-ons and the discount codes are appended to every /cart/VARIANT:1 permalink on the page.
// Runs after the offer script, so a rejected email has already cleared its claim.
(function () {
  var boxes = document.querySelectorAll('.bf [data-bf-addon]');
  var links = [].filter.call(document.querySelectorAll('.bf a.bf-btn, .bf a.bf-pick-btn, .bf a.bf-sticky'), function (a) { return /^\/cart\//.test(a.getAttribute('href')); });
  links.forEach(function (a) { a.dataset.base = a.getAttribute('href'); });
  var claimed = false;
  try { claimed = !!localStorage.getItem('bf-offer-claimed-at'); } catch (e) { /* no code */ }
  function update() {
    var extra = [].filter.call(boxes, function (b) { return b.checked; }).map(function (b) { return b.getAttribute('data-bf-addon') + ':1'; });
    var codes = claimed ? ['BF10'] : [];
    // BFADDON is a buy-X-get-Y code: it only discounts the add-ons when the bundle is in the cart.
    if (extra.length) codes.push('BFADDON');
    links.forEach(function (a) {
      var url = a.dataset.base + (extra.length ? ',' + extra.join(',') : '');
      a.setAttribute('href', url + (codes.length ? (url.indexOf('?') < 0 ? '?' : '&') + 'discount=' + codes.join(',') : ''));
    });
  }
  boxes.forEach(function (b) { b.addEventListener('change', update); });
  update(); // a restored (back-button) checkbox state is picked up too
})();
